import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SettingsProvider } from "@/lib/useSettings";

import PublicLayout from "@/components/public/PublicLayout";
import HomePage from "@/pages/public/HomePage";
import { ServicesListPage, ServiceDetailPage } from "@/pages/public/ServicesPage";
import { RealisationsListPage, RealisationDetailPage } from "@/pages/public/RealisationsPage";
import { BlogListPage, BlogDetailPage } from "@/pages/public/BlogPage";
import ZonePage from "@/pages/public/ZonePage";
import { ContactPage, DevisPage, LegalPage } from "@/pages/public/MiscPages";
import LocalPage from "@/pages/public/LocalPage";

import LoginPage from "@/pages/admin/LoginPage";
import PodSsoConsumePage from "@/pages/admin/PodSsoConsumePage";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import RealisationsAdmin from "@/pages/admin/RealisationsAdmin";
import BlogAdmin from "@/pages/admin/BlogAdmin";
import { FAQAdmin, ZonesAdmin } from "@/pages/admin/SimpleAdminPages";
import LeadsAdmin from "@/pages/admin/LeadsAdmin";
import { RankTrackerAdmin, AnalyticsAdmin, LocalSEOAdmin } from "@/pages/admin/AdvancedAdminPages";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import SupportAdmin from "@/pages/admin/SupportAdmin";
import MediaAdmin from "@/pages/admin/MediaAdmin";
import ShortLinksAdmin from "@/pages/admin/ShortLinksAdmin";
import AgencyPairingPage from "@/pages/admin/AgencyPairingPage";
import AgentBridgePage from "@/pages/admin/AgentBridgePage";
import EmailLogAdmin from "@/pages/admin/EmailLogAdmin";
import ShortLinkRedirect from "@/pages/ShortLinkRedirect";

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            {/* PUBLIC */}
            <Route element={<PublicLayout/>}>
              <Route path="/" element={<HomePage/>}/>
              <Route path="/services" element={<ServicesListPage/>}/>
              <Route path="/services/:slug" element={<ServiceDetailPage/>}/>
              <Route path="/realisations" element={<RealisationsListPage/>}/>
              <Route path="/realisations/:slug" element={<RealisationDetailPage/>}/>
              <Route path="/blog" element={<BlogListPage/>}/>
              <Route path="/blog/:slug" element={<BlogDetailPage/>}/>
              <Route path="/zones/:slug" element={<ZonePage/>}/>
              <Route path="/intervention/:slug" element={<LocalPage/>}/>
              <Route path="/contact" element={<ContactPage/>}/>
              <Route path="/devis" element={<DevisPage/>}/>
              <Route path="/mentions-legales" element={<LegalPage kind="mentions"/>}/>
              <Route path="/cgv" element={<LegalPage kind="cgv"/>}/>
              <Route path="/confidentialite" element={<LegalPage kind="confidentialite"/>}/>
            </Route>

            {/* SHORT LINK — public redirect */}
            <Route path="/l/:slug" element={<ShortLinkRedirect/>}/>

            {/* ADMIN */}
            <Route path="/admin/login" element={<LoginPage/>}/>
            <Route path="/admin/sso" element={<PodSsoConsumePage/>}/>
            <Route path="/admin" element={<AdminLayout/>}>
              <Route index element={<Dashboard/>}/>
              <Route path="dashboard" element={<Dashboard/>}/>
              <Route path="services" element={<ServicesAdmin/>}/>
              <Route path="realisations" element={<RealisationsAdmin/>}/>
              <Route path="blog" element={<BlogAdmin/>}/>
              <Route path="faq" element={<FAQAdmin/>}/>
              <Route path="zones" element={<ZonesAdmin/>}/>
              <Route path="leads" element={<LeadsAdmin/>}/>
              <Route path="analytics" element={<AnalyticsAdmin/>}/>
              <Route path="rank-tracker" element={<RankTrackerAdmin/>}/>
              <Route path="local-seo" element={<LocalSEOAdmin/>}/>
              <Route path="support" element={<SupportAdmin/>}/>
              <Route path="media" element={<MediaAdmin/>}/>
              <Route path="short-links" element={<ShortLinksAdmin/>}/>
              <Route path="agency-pairing" element={<AgencyPairingPage/>}/>
              <Route path="agent-bridge" element={<AgentBridgePage/>}/>
              <Route path="emails" element={<EmailLogAdmin/>}/>
              <Route path="settings" element={<SettingsAdmin/>}/>
            </Route>
          </Routes>
          <Toaster position="top-right" richColors/>
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}
